import Gigya, { BaseParams } from './gigya.js'

export type Asset = {
	type: string
	path: string
	actions: string[]
	attributes: Record<string, string[]>
}

export type GetAssetsResponse = {
	allowedAssets: Asset[]
	businessEntities?: unknown[]
	accessPolicies?: [
		{
			name: string
			restricted: boolean
			ID: string
		}
	]
}

export type GetAssetsParams = {
	uid: string
	bpId: string
	appId: string
	environments?: {
		environment?: Record<string, string[]>
	}
	identity?: {
		id?: string
	}
	context?: {
		organization?: string
		originating_ip?: string
	}
	response?: {
		include_identity?: boolean
		include_reasons?: boolean
		include_policy_external_id?: boolean
		include_business_models?: boolean
	}
	clientId?: string
	apiKey?: string
}

export type GetPoliciesParams = {
	roleIds?: string[]
	context?: Record<string, any> | string
}

export type GetPoliciesResponse = {
	requestedPolicies: [
		{
			policyName: string
			roleId: string
		}
	]
	policiesNotFound?: [{ roleId: string }]
}

export class AccountsB2bAuth {
	constructor(protected gigya: Gigya) {}

	public getAssets(params: BaseParams & GetAssetsParams) {
		return this.gigya.request<GetAssetsResponse>('accounts.b2b.auth.getAssets', params)
	}

	public getPolicies(params: BaseParams & GetPoliciesParams) {
		return this.gigya.request<GetPoliciesResponse>('accounts.b2b.auth.getPolicies', params)
	}
}
